module.exports = __webpack_public_path__ + "img/conductor-blue.f31eb74d.svg";